import React from 'react';

const SearchResult = ({ searchResult, building, room }) => {
  if (!searchResult) return null;
  
  const { 
    available, 
    examDetails, 
    upcomingToday,
    upcomingExams,    // Add this
    hasUpcomingExams, // Add this
    ongoingExam,
    hasOngoingExam, 
    completedExams,
    hasCompletedExamsOnly,
    dateExams, 
    invalidRoom, 
    invalidBuilding,
    roomsInBuilding,
    checkDate 
  } = searchResult;
  
  // Format date string for UI display
  const dateText = checkDate !== 'today' ? checkDate : 'Today';
  
  return (
    <div className="mt-8">
      {invalidRoom ? (
        invalidBuilding ? (
          <div className="flex items-center p-8 bg-red-50 dark:bg-red-950/30 rounded-xl border border-red-100 dark:border-red-900/40">
            <div className="rounded-full bg-red-500 p-3 mr-6">
              <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              </svg>
            </div>
            <div>
              <h3 className="text-xl font-medium text-red-800 mb-1">Invalid Building</h3>
              <p className="text-gray-500">Building {building} does not exist in the exam schedule database.</p>
              <p className="text-sm text-gray-400 mt-2">No exams are scheduled in this building during finals period.</p>
            </div>
          </div>
        ) : (
          <div className="flex items-center p-8 bg-red-50 dark:bg-red-950/30 rounded-xl border border-red-100 dark:border-red-900/40">
            <div className="rounded-full bg-red-500 p-3 mr-6">
              <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              </svg>
            </div>
            <div>
              <h3 className="text-xl font-medium text-red-800 mb-1">Room Not Found</h3>
              <p className="text-gray-500 mb-2">Building {building}, Room {room} could not be found in the exam schedule.</p>
              <p className="text-sm text-gray-500">This could mean:</p>
              <ul className="list-disc list-inside text-sm text-gray-500 mt-1 ml-2">
                <li>The room number is incorrect</li>
                <li>This room has no exams scheduled during finals period</li>
                <li>This room is not used for exams</li>
              </ul>
              {roomsInBuilding && roomsInBuilding.length > 0 && (
                <div className="mt-3">
                  <p className="text-sm text-gray-500">Rooms in Building {building} with exams scheduled:</p>
                  <div className="mt-1 flex flex-wrap gap-1">
                    {roomsInBuilding.slice(0, 10).map(r => (
                      <span key={r} className="inline-block px-2 py-1 bg-gray-100 text-xs rounded">{r}</span>
                    ))}
                    {roomsInBuilding.length > 10 && <span className="text-xs text-gray-400">+{roomsInBuilding.length - 10} more</span>}
                  </div>
                </div>
              )}
            </div>
          </div>
        )
      ) : checkDate !== 'today' ? (
        available ? (
          <div className="flex items-center p-8 bg-green-50 rounded-xl">
            <div className="rounded-full bg-green-500 p-3 mr-6">
              <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
              </svg>
            </div>
            <div>
              <h3 className="text-xl font-medium text-green-800 mb-1">Room Available on {dateText}</h3>
              <p className="text-gray-500">Building {building}, Room {room} has no exams scheduled on this date.</p>
            </div>
          </div>
        ) : (
          <div className="flex items-center p-8 bg-red-50 rounded-xl">
            <div className="rounded-full bg-red-500 p-3 mr-6">
              <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              </svg>
            </div>
            <div>
              <h3 className="text-xl font-medium text-red-800 mb-1">Room Unavailable on {dateText}</h3>
              <p className="text-gray-500 dark:text-gray-300 mb-2">This room has exams scheduled on this date:</p>
              <div className="space-y-2">
                {dateExams.map((exam, index) => (
                  <div key={index} className="text-sm py-2 px-4 bg-white dark:bg-gray-900 rounded-lg shadow-sm inline-block border border-gray-100 dark:border-gray-800 mr-2">
                    <span className="font-medium text-gray-900 dark:text-gray-100">{exam.course}</span> • <span className="text-gray-700 dark:text-gray-200">{exam.time}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        )
      ) : hasOngoingExam ? (
  <div className="flex items-center p-8 bg-red-50 dark:bg-red-950/30 rounded-xl border border-red-100 dark:border-red-900/40">
          <div className="rounded-full bg-red-500 p-3 mr-6">
            <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
          </div>
          <div>
            <h3 className="text-xl font-medium text-red-800 mb-1">Room Currently In Use</h3>
            <p className="text-gray-500 dark:text-gray-300 mb-2">This room has an exam in progress right now:</p>
            <div className="text-sm py-2 px-4 bg-white dark:bg-gray-900 rounded-lg shadow-sm inline-block border border-red-100 dark:border-red-900/40">
              <span className="font-medium text-gray-900 dark:text-gray-100">{ongoingExam.course}</span> • <span className="text-gray-700 dark:text-gray-200">{ongoingExam.time}</span> 
              <span className="ml-2 px-2 py-0.5 text-xs bg-red-100 dark:bg-red-900/40 text-red-800 dark:text-red-300 rounded-full">ONGOING</span>
            </div>
          </div>
        </div>
      ) : hasCompletedExamsOnly ? (
  <div className="flex items-center p-8 bg-green-50 dark:bg-green-950/30 rounded-xl border border-green-100 dark:border-green-900/40">
          <div className="rounded-full bg-green-500 p-3 mr-6">
            <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
            </svg>
          </div>
          <div>
            <h3 className="text-xl font-medium text-green-800 mb-1">Room Available Now</h3>
            <p className="text-gray-500 dark:text-gray-300 mb-2">This room had exam(s) earlier today, but they've ended:</p>
            <div className="space-y-2">
              {completedExams.map((exam, index) => (
                <div key={index} className="text-sm py-2 px-4 bg-white dark:bg-gray-900 rounded-lg shadow-sm inline-block border border-gray-100 dark:border-gray-800 mr-2">
                  <span className="font-medium text-gray-900 dark:text-gray-100">{exam.course}</span> • <span className="text-gray-700 dark:text-gray-200">{exam.time}</span> 
                  <span className="ml-2 px-2 py-0.5 text-xs bg-gray-100 dark:bg-gray-800 text-gray-600 dark:text-gray-300 rounded-full">COMPLETED</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      ) : available ? (
  <div className="flex items-center p-8 bg-green-50 dark:bg-green-950/30 rounded-xl border border-green-100 dark:border-green-900/40">
          <div className="rounded-full bg-green-500 p-3 mr-6">
            <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
            </svg>
          </div>
          <div>
            <h3 className="text-xl font-medium text-green-800 mb-1">Room Available Today</h3>
            <p className="text-gray-500 dark:text-gray-300">Building {building}, Room {room} has no exams scheduled today.</p>
          </div>
        </div>
      ) : hasUpcomingExams ? (
  <div className="flex items-center p-8 bg-amber-50 dark:bg-amber-950/30 rounded-xl border border-amber-100 dark:border-amber-900/40">
          <div className="rounded-full bg-amber-500 p-3 mr-6">
            <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
          </div>
          <div>
            <h3 className="text-xl font-medium text-amber-800 mb-1">Room Available Now, But Not Later</h3>
            <p className="text-gray-500 dark:text-gray-300 mb-2">This room has {upcomingExams.length > 1 ? 'upcoming exams' : 'an upcoming exam'} today:</p>
            <div className="space-y-2">
              {upcomingExams.map((exam, index) => (
                <div key={index} className="text-sm py-2 px-4 bg-white dark:bg-gray-900 rounded-lg shadow-sm inline-block border border-amber-100 dark:border-amber-900/40 mr-2 mb-2">
                  <span className="font-medium text-gray-900 dark:text-gray-100">{exam.course}</span> • <span className="text-gray-700 dark:text-gray-200">{exam.time}</span>
                  <span className="ml-2 px-2 py-0.5 text-xs bg-amber-100 dark:bg-amber-900/40 text-amber-800 dark:text-amber-300 rounded-full">UPCOMING</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      ) : examDetails ? (
  <div className="flex items-center p-8 bg-red-50 dark:bg-red-950/30 rounded-xl border border-red-100 dark:border-red-900/40">
          <div className="rounded-full bg-red-500 p-3 mr-6">
            <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </div>
          <div>
            <h3 className="text-xl font-medium text-red-800 mb-1">Room Unavailable Today</h3>
            <p className="text-gray-500 dark:text-gray-300 mb-2">This room has an exam scheduled today:</p>
            <div className="text-sm py-2 px-4 bg-white dark:bg-gray-900 rounded-lg shadow-sm inline-block border border-gray-100 dark:border-gray-800">
              <span className="font-medium text-gray-900 dark:text-gray-100">{examDetails.course}</span> • <span className="text-gray-700 dark:text-gray-200">{examDetails.time}</span>
            </div>
          </div>
        </div>
      ) : (
        <div className="p-8 bg-gray-50 dark:bg-gray-900 rounded-xl text-center border border-gray-100 dark:border-gray-800">
          <p className="text-gray-500 dark:text-gray-300">No data available for this room.</p>
        </div>
      )}
    </div>
  );
};

export default SearchResult;